import styled from 'styled-components';
import { white, primary, black, middleGray } from 'styles/colorProvider';

export const Container = styled.div`
  background-color: ${white};
  width: 100%;
  height: 100% !important;
  max-height: 100% !important;
  overflow-y: hidden !important;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const ContentArea = styled.div`
  display: flex;
  align-items: left;
  flex-direction: column;
  width: 90%;
  height: 100% !important;
  max-height: 100% !important;
  box-sizing: border-box;
  padding: 30px;
  padding-left: 90px;
  position: relative;

  @media (max-width: 1000px) {
    width: 100%;
    padding-left: 20px;
  }
`;

export const Title = styled.h1`
  font-size: 28px;
  color: ${primary};
  margin-bottom: 10px;

  @media (max-width: 1000px) {
    margin: 20px 0px;
  }
`;

export const Div = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 1000px) {
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .containerTitle {
    display: flex;
    width: 40%;
    justify-content: flex-end;
    flex-direction: row;
    align-items: center;

    @media (max-width: 1000px) {
      width: 100%;
    }
  }
`;

export const DataArea = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: 65vh !important;
  max-height: 65vh !important;
  overflow: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: 10px;

  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${primary};
    border-radius: 10px;
  }

  @media (max-width: 1000px) {
    margin-top: 20px;
    padding: 20px;
  }
`;

export const LoadingArea = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-top: 100px;
`;

export const CountArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  font-size: 12px;

  p {
    margin: 0px;
  }
`;

export const ModalButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: right;
  align-items: center;
  width: 100%;
  gap: 10px;

  @media (max-width: 1000px) {
    justify-content: center;
    flex-direction: column;
  }
`;

export const FilterModalForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const FilterLabel = styled.p`
  color: ${black};
  font-size: 12px;
  margin: 0 0 5px 0;
`;

export const FilterDivPicker = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 300px;

  .MuiFormControl-root {
    width: 100%;
    margin: 0;
  }

  .MuiInputBase-root {
    height: 30px;
    border-radius: 10px;
    background-color: ${white} !important;
    border: 1px solid ${middleGray};
    font-size: 15px;
    padding-left: 5px;
    padding-right: 5px;
  }

  .MuiInputBase-input {
    padding: 0 8px;
    height: 28px;
    font-size: 15px;
  }

  .MuiFilledInput-underline:before,
  .MuiFilledInput-underline:after {
    display: none;
  }

  .MuiInputLabel-filled {
    display: none;
  }

  @media (max-width: 1000px) {
    width: 100%;
  }
`;
